import React, { useContext } from "react";
import type { Answer } from "types/answer";
import type { ProfileClinical } from "types/profile";
import type { Question } from "types/question";
import { LOGGED_IN_AS } from "./Profile/constants";

export const AppContext = React.createContext({});

export const AppProvider = AppContext.Provider;

export interface AppContextType {
  assessment?: {
    questions: Question[];
  }
  answers?: Answer[];
  setAnswers?: (answers: Answer[]) => void;
  profile?: ProfileClinical;
  setProfile?: (profile: Partial<ProfileClinical>) => void;
  theme?: string;
  nextStack?: Answer[];
  contact?: {
    market: string;
  }
  newQuiz?: {
    isUni: boolean;
    isUni1: boolean;
    isUni2: boolean;
    isUni3: boolean;
    isUni4: boolean;
    isUni5: boolean;
    eli: boolean;
    isSequenceResultsScreen: boolean;
    coreUrl: string;
    eliUrl: string;
    dbSlugs: string;
    isAndroid: boolean;
    isIphone: boolean;
    isSequence: boolean;
    isClinical: boolean;
    isFoodNoise: boolean;
  }
  authData?: {
    [LOGGED_IN_AS]: string;
  }
  setAuthData?: (authData: { [LOGGED_IN_AS]: string }) => void;
}

const useAppContext = (): AppContextType => useContext<AppContextType>(AppContext);

export default useAppContext;
